import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import PURCHASEIRQSeeVaLoanOptionsView from "../views/IrqSeeVaLoanOptionsView";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { bool, object } from "yup";
import StatusCheck from "../components/StatusCheck";

class PurchaseIrqSeeVaLoanOptionsPage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="purchaseIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            lookAtVaLoans: bool().required(),
          })}
        >
          <PURCHASEIRQSeeVaLoanOptionsView
            content={contentMap.PurchaseIrqSeeVaLoanOptionsPage}
            navigationsAway={
              customNavigationMap.PurchaseIrqSeeVaLoanOptionsPage
            }
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(PurchaseIrqSeeVaLoanOptionsPage);
